// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19G5k","label":"styles_label__2jys7"};